// Shared hooks between the builder's parts (App, footer tabs, My Builds, the desktop drawer, share).
// Each part puts the functions it owns here and calls the others' through it. These used to hang off
// window (window.__ohmaSaveDesign, window.__ohmaRefreshBuilds, ...), visible to every script on the page.
export const builderBus = {}
